import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { useStores } from '../hooks/use-stores';

const PrivateRoute = ({ children, notLoggedUrl }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const { authStore } = useStores();

    if (!notLoggedUrl) {
        notLoggedUrl = `/auth/signin?redirect=${encodeURIComponent(location.pathname + location.search)}`;
    }

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        if (
            queryParams.has('sso') &&
            authStore.isAuthenticated === true &&
            authStore.token != null
        ) {
            queryParams.delete('sso');
            navigate(`?${queryParams.toString()}`, { replace: true });
        }
    }, [location.search, authStore.isAuthenticated, authStore.token, navigate]);

    const isLoggedIn =
        authStore.isAuthenticated === true && authStore.token != null;

    if (!isLoggedIn) {
        if (
            notLoggedUrl &&
            (notLoggedUrl.startsWith('http://') ||
                notLoggedUrl.startsWith('https://'))
        ) {
            window.location = notLoggedUrl;
            return null;
        }
        return <Navigate replace={true} to={notLoggedUrl} />;
    }

    return <>{children}</>;
};

export default observer(PrivateRoute);
